import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';
import { Button as StyledButton } from '../styles';

export const GetStartedButton = styled(StyledButton, {
  shouldForwardProp: prop => prop !== 'isScrolled'
})<{ isScrolled?: boolean }>`
  z-index: 1;
  flex: 1 1 auto;
  align-self: center;
  white-space: nowrap;
  overflow: hidden;
  min-width: fit-content;
  -webkit-tap-highlight-color: transparent;

  transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 1.01);
  will-change: width, flex-grow;

  ${({ isScrolled, theme }) => `
    font-size: ${isScrolled ? theme.fontSize.s : theme.fontSize.sm};
    height: ${isScrolled ? pxToRem(40) : pxToRem(56)};
    min-height: ${pxToRem(32)};
    width: ${isScrolled ? pxToRem(104) : pxToRem(286)};
    border-radius: ${
      isScrolled
        ? theme.borderRadius.input_mobile_nav
        : theme.borderRadius.input_desktop
    };
  `}
  

  ${mediaQueries.desktop} {
    height: ${pxToRem(64)};
    width: ${pxToRem(286)};
    font-size: ${({ theme }) => theme.fontSize.sm}
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  }
`;
